var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2902_5914)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.78125C3.78938 0.78125 0.78125 3.78938 0.78125 7.5C0.78125 11.2106 3.78938 14.2188 7.5 14.2188C11.2106 14.2188 14.2188 11.2106 14.2188 7.5C14.2188 3.78938 11.2106 0.78125 7.5 0.78125ZM9.6875 8.90625C9.4803 8.90625 9.28159 8.98856 9.13507 9.13507C8.98856 9.28159 8.90625 9.4803 8.90625 9.6875C8.90625 9.8947 8.98856 10.0934 9.13507 10.2399C9.28159 10.3864 9.4803 10.4688 9.6875 10.4688C9.8947 10.4688 10.0934 10.3864 10.2399 10.2399C10.3864 10.0934 10.4688 9.8947 10.4688 9.6875C10.4688 9.4803 10.3864 9.28159 10.2399 9.13507C10.0934 8.98856 9.8947 8.90625 9.6875 8.90625ZM4.53125 5.3125C4.53125 5.1053 4.61356 4.90659 4.76007 4.76007C4.90659 4.61356 5.1053 4.53125 5.3125 4.53125C5.5197 4.53125 5.71841 4.61356 5.86493 4.76007C6.01144 4.90659 6.09375 5.1053 6.09375 5.3125C6.09375 5.5197 6.01144 5.71841 5.86493 5.86493C5.71841 6.01144 5.5197 6.09375 5.3125 6.09375C5.1053 6.09375 4.90659 6.01144 4.76007 5.86493C4.61356 5.71841 4.53125 5.5197 4.53125 5.3125ZM9.66875 4.66875C9.71166 4.6227 9.76341 4.58576 9.82091 4.56014C9.87841 4.53452 9.94048 4.52074 10.0034 4.51963C10.0664 4.51852 10.1289 4.5301 10.1872 4.55367C10.2456 4.57725 10.2986 4.61234 10.3431 4.65685C10.3877 4.70136 10.4228 4.75438 10.4463 4.81275C10.4699 4.87112 10.4815 4.93364 10.4804 4.99658C10.4793 5.05952 10.4655 5.12159 10.4399 5.17909C10.4142 5.23659 10.3773 5.28834 10.3313 5.33125L5.33125 10.3313C5.24239 10.4141 5.12486 10.4591 5.00342 10.457C4.88199 10.4548 4.76612 10.4056 4.68024 10.3198C4.59435 10.2339 4.54516 10.118 4.54302 9.99658C4.54087 9.87514 4.58595 9.75761 4.66875 9.66875L9.66875 4.66875Z",
    fill: "#5881FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2902_5914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentage);
export default __webpack_public_path__ + "static/media/icon_percentage.238582a50e530c7bdafe8388b84de2ea.svg";
export { ForwardRef as ReactComponent };